import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { PlusCircle } from 'react-feather';

import s from './SidebarHeading.css';

const SidebarHeading = props =>
  <h4 className={s.sidebarHeading} data-qa={props.qaId}>
    {props.actionUrl &&
      <Link
        to={props.actionUrl}
        className={s.actionItem}
        data-qa={`${props.qaId}-action`}
      >
        <PlusCircle size={21} />
      </Link>
    }
    <span data-qa={props.qaId  + "-title"}>{props.title}</span>
  </h4>
;

SidebarHeading.propTypes = {
  qaId: PropTypes.string,
  actionUrl: PropTypes.string,
  title: PropTypes.string.isRequired
};

export default SidebarHeading;